module.exports = __webpack_public_path__ + "static/media/FewCloudsSun02d.d84298d3.png";